export default __webpack_public_path__ + "static/media/home.109ec67c.svg";